import { container } from '@/container';
import CONSTANTS from '@/helpers/constants';
import { Logger } from '@/services/Logger';
import { PatientTripUpdateReq } from '@/services/signalr/MessageTypes/TripUpdateReq';
import { Signalr } from '@/services/signalr/Signalr';

const logger = container.get(Logger);

export interface UpdatePatientWithTripParams {
  tripId: string;
  patientId: string;
}

/**
 * Associate a patient with a trip via SignalR.
 * @param params - The association parameters
 */
export async function updatePatientWithTrip(params: UpdatePatientWithTripParams): Promise<void> {
  try {
    const signalr = await container.getAsync(Signalr);
    await signalr.invoke(PatientTripUpdateReq, {
      contextKey: CONSTANTS.UI.CONTEXTS.PATIENT_UPDATE_WITH_TRIP,
      Id: params.tripId,
      Patient: {
        Id: params.patientId,
      },
    });
  }
  catch (error) {
    logger.captureException(error as Error, { tags: { updateTrip: CONSTANTS.UI.CONTEXTS.PATIENT_UPDATE_WITH_TRIP } });
    throw error;
  }
}
